export default __webpack_public_path__ + "static/media/3080.af20cc7d.jpg";